import React from 'react'

import { tx } from '@twind/core'

type ContentWrapperProps = {
  children: React.ReactNode
  className?: string
}

export const ContentWrapper = ({
  children,
  className
}: ContentWrapperProps) => {
  return (
    <div className={tx('bg-[#1C1C21] flex flex-col', className)}>
      {children}
    </div>
  )
}
